module.exports = __webpack_public_path__ + "static/media/pic_qingyu.ed3c479d.png";